import { FeatureFlagService } from "./FeatureFlagService";
import config from "../../config";
import FeatureFlagProviderFactory from "./FeatureFlagFactory";

const featureFlagService = new FeatureFlagService(
  FeatureFlagProviderFactory.createProvider(
    config.featureFlagConfig.featureFlagProvider,
    config.featureFlagConfig.sdkKey,
    config.featureFlagConfig.environment,
  )
);

export default featureFlagService;